import { pathOr } from 'ramda';

import { PAGE_REQUEST } from 'store/app/actions';

import { getErrorMessage } from 'utils/stringUtils';

import { types } from './actions';
import { AUTH_STEPS } from './constants';

const initialState = {
  isFetching: false,
  isDiscovering: false,
  authStep: AUTH_STEPS.EMAIL,
  error: null,
  showTermsAcceptanceModal: false,
  passwordResetSent: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PAGE_REQUEST:
      return {
        ...initialState,
        showTermsAcceptanceModal: state.showTermsAcceptanceModal,
      };
    case types.DISCOVER:
      return { ...state, isDiscovering: true, error: null };
    case types.DISCOVER_SUCCESS:
      return { ...state, isDiscovering: false, authStep: action.payload.step };
    case types.DISCOVER_RESET:
      return {
        ...state,
        isDiscovering: false,
        authStep: AUTH_STEPS.EMAIL,
        error: null,
        // Otherwise a user who goes back to fix a mistyped address returns to
        // a locked check-your-inbox panel instead of a fresh password step.
        passwordResetSent: false,
      };
    case types.LOGIN:
      return { ...state, isFetching: true };
    case types.LOGIN_SUCCESS: {
      const showTermsAcceptanceModal = pathOr(
        false,
        ['user', 'termsAcceptanceRequired'],
        action.payload,
      );
      return {
        ...state,
        showTermsAcceptanceModal,
        isFetching: false,
      };
    }
    case types.LOGIN_ERROR:
      return {
        ...state,
        error: getErrorMessage(action.payload),
        isFetching: false,
      };
    case types.PASSWORD_RESET_REQUIRED:
      return {
        ...state,
        passwordResetSent: true,
        isFetching: false,
      };
    case types.LOGOUT_SUCCESS:
      return initialState;
    case types.ACCEPT_TERMS_SUCCESS:
      return { ...state, showTermsAcceptanceModal: false };
    default:
      return state;
  }
};

export default reducer;
